export default {
  ThemeStatus: {
    Deleted: 0,
    Draft: 1,
    Active: 10,
    Default: 20,
  },
  Langs: [
    'en',
    'ru',
    'cn',
    'ar',
    'ua',
    'es',
    'id',
    'de',
    'pl',
    'fr',
    'th',
    'ms',
    'tr',
    'ko',
    'ja',
    'it',
    'cs',
    'pt',
    'nb',
  ],
  DefaultLang: 'en',
};
